import Banner from "./components/Banner";

const ProfileOverview = () => {
  return <Banner />;
};

export default ProfileOverview;
